<app-side-top-bar [navigationItems]="navigationItems">
  <main class="invoices-page">
    <section class="invoices-section">
      <header class="header">
        <h2>{{ labelService.getLabel("invoices") }}</h2>
        <div class="header-buttons">
          <button
            mat-stroked-button
            color="primary"
            class="button-invoices"
            (click)="navigateToNewSts()"
            [disabled]="!areSTSBillingDataCorrect"
            [matTooltip]="!areSTSBillingDataCorrect ? doctorSTSErrorFields : ''"
            matTooltipPosition="below"
          >
            <mat-icon>add</mat-icon>
            STS
          </button>
          <button
            mat-stroked-button
            color="primary"
            class="button-invoices"
            (click)="toggleCreateModifyInvoiceSDIPanel()"
            [disabled]="!areSDIBillingDataCorrect"
            [matTooltip]="!areSDIBillingDataCorrect ? doctorSDIErrorFields : ''"
            matTooltipPosition="below"
          >
            <mat-icon>add</mat-icon>
            SDI
          </button>
          <button
            mat-icon-button
            aria-label="Info"
            class="info-button"
            (click)="toggleInfoPanel()"
          >
            <mat-icon>info</mat-icon>
          </button>
        </div>
      </header>
      <app-table-invoices
        [invoices]="invoices"
        [areSDIBillingDataCorrect]="areSDIBillingDataCorrect"
        [areSTSBillingDataCorrect]="areSTSBillingDataCorrect"
        [isLoadingInvoices]="isLoadingInvoices"
        (selectedInvoice)="toggleModifyDraftPanel($event)"
        (deletedInvoice)="deleteInvoice($event)"
        (sentInvoice)="sendInvoice($event)"
        (duplicatedInvoice)="duplicateInvoice($event)"
        (showedNotifications)="toggleNotificationsPanel($event)"
        (pagataChanged)="onPagataChange($event)"
        (deleteSelectedInvoices)="deleteInvoicesDispatcher($event)"
        (modifyPaymentDate)="toggleInvoicePaymentDatePanel($event)"
        (sendSelectedInvoices)="sendInvoicesDispatcher($event)"
        (downloadedInvoiceSTSPDF)="downloadInvoiceSTSPDF($event)"
        (downloadedInvoiceSDIPDF)="downloadInvoiceSDIPDF($event)"
        (shownReceipt)="getReceipt($event)"
        (sendEmail)="sendEmailToClientDispatcher($event)"
        (promotedStsDraft)="promoteStsDraftToReadyFromList($event)"
        (viewStsSummary)="viewStsSummaryFromList($event)"
        (issueStsCreditNote)="issueStsCreditNoteFromList($event)"
        (revertedInvoice)="revertInvoiceToBozzaDispatcher($event)"
      ></app-table-invoices>
    </section>
    @if (showNotificationsPanel) {
      <app-invoices-notification-panel
        [selectedInvoice]="selectedInvoice"
        (closePanel)="toggleNotificationsPanel()"
      ></app-invoices-notification-panel>
    }
  </main>
</app-side-top-bar>
@if (showInfoPanel) {
  <app-invoices-info-panel
    (close)="toggleInfoPanel()"
  ></app-invoices-info-panel>
}
@if (showCreateModifyInvoiceSDIPanel) {
  <app-panel-create-modify-invoice-sdi
    [selectedInvoice]="selectedInvoice"
    [newInvoicePanelTitle]="newInvoicePanelTitle"
    [doctorSDIErrorFields]="doctorSDIErrorFields"
    (cancel)="toggleCreateModifyInvoiceSDIPanel()"
    (saveDraftSDI)="createInvoiceSDIDraft($event)"
    (modifyDraftSDI)="modifyInvoiceSDIDraft($event)"
    (saveReadySDI)="createInvoiceSDIReady($event)"
    (modifyReadySDI)="promoteDraftInvoiceSDIToReady($event)"
  ></app-panel-create-modify-invoice-sdi>
}
@if (showPaymentDatePanel) {
  <app-invoices-panel-modify-payment-date
    [invoice]="selectedInvoice"
    (closePanel)="toggleInvoicePaymentDatePanel()"
    (confirmNewPaymentDate)="onConfirmNewPaymentDate($event)"
  ></app-invoices-panel-modify-payment-date>
}
